import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SupportedLocale } from "../enums/componentEnums";
import { selectLanguage, setLanguage } from "../store/language";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectLanguage);

  const changeLanguage = (lng: SupportedLocale) => {
    i18n.changeLanguage(lng);
    dispatch(setLanguage(lng));
    // localStorage.setItem("i18nextLng", lng); // optional: persist language
  };

  return (
    <div className="rounded border px-2 py-1 cursor-pointer">
      <select
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value as SupportedLocale)}
        className="rounded border px-2 py-1 cursor-pointer"
      >
        <option className="cursor-pointer" value={SupportedLocale.EN_US}>English</option>
        <option className="cursor-pointer" value={SupportedLocale.FR_FR}>Français</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
